import React, { Component } from "react";

import { Helmet } from "react-helmet";

import Hero from "components/PageHero/Hero";
import TextBlock from "components/TextBlock/TextBlock";
import Sidebar from "components/Sidebar/Sidebar";
import ArticleGrid from "components/ArticleGrid/ArticleGrid";
import ArticleGridItem from "components/ArticleGrid/ArticleGridItem";
import InformationItem from "components/InformationItem/Information-Item";
import { sidebarControl } from "helpers/Helpers";
import { translate } from "react-i18next";

class Assortment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: [],
      loading: true,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", sidebarControl);
    document.body.classList.add("assorti-page");

    this.loadWordpressPage();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", sidebarControl);
    document.body.classList.remove("assorti-page");
  }

  UNSAFE_componentWillReceiveProps() {
    this.loadWordpressPage();
  }

  getCountryPageId() {
    let pageId = '168';
    const language = this.props.t('lang');
    switch (language) {
      case "en":
        pageId = 202;
        break;
      case "de":
        pageId = 204;
        break;
      case "fr":
        pageId = 200;
        break;
      default:
        pageId = 168;
    }
    
    return `${process.env.REACT_APP_API_URL}wp/v2/pages/${pageId}`
  }

  async loadWordpressPage() {
    const url = this.getCountryPageId();

    await fetch(url)
      .then(res => res.json())
      .then(page => this.setState((prevState, props) => {
        return { page: page.acf };
      }));
  }

  render() {
    const page = this.state.page;
    if (page.length === 0) {
      return (
        <div>Loading page</div>
      );
    } else {
      const pagedetails = this.state.page;

      return [
        <Helmet key="head">
          <meta charSet="utf-8" />
          <title>
            Assortiment | Forever Plants | Tropische en Exotische Potplanten
          </title>
          <meta
            property="og:image"
            content={pagedetails.header_image}
          />
          <meta
            name="description"
            content="Bij Forever Plants verkopen we bijna alles dat tropisch, exotisch en groen is. In onze Green Energy collectie vindt je planten uit Midden-Amerika, zoals onze meest verkochte Yucca of verschillende soorten van de Dracaena. Maar ook met de Ficus, Curcuma en Hibisqs haal je de tropen in huis."
          />
          <meta
            property="og:description"
            content="Bij Forever Plants verkopen we bijna alles dat tropisch, exotisch en groen is. In onze Green Energy collectie vindt je planten uit Midden-Amerika, zoals onze meest verkochte Yucca of verschillende soorten van de Dracaena. Maar ook met de Ficus, Curcuma en Hibisqs haal je de tropen in huis."
          />
        </Helmet>,
        <main id="pageWrapper" key="content">
          <div className="wrapper-hero-video">
            <Hero imageSrc={pagedetails.header_image} />
            <div className="flex assort-content-wrapper">
              <div className="sidebar">
                <Sidebar />
              </div>
              <div className="wrapper wrapper--mobile">
                <section>
                  <TextBlock
                    title={pagedetails.titel}
                    subtitle={pagedetails.subtitel}
                  >
                    {pagedetails.hoofdtekst}
                  </TextBlock>
                </section>
                {pagedetails.producten.map(function(serie, i) {
                  return (
                    <section className="mt30">
                      <TextBlock title={serie.titel}>
                        <span  dangerouslySetInnerHTML={{ __html: serie.tekst }} />
                      </TextBlock>
                      <ArticleGrid className="ArticleGrid ArticleGrid--assorti mt30 swiper-container">
                        {serie.product_images.map(function(image, i) {
                          return (
                            <ArticleGridItem
                              className="mr60"
                              imageSrc={image.product_afbeelding}
                              imageSrcHq={image.product_afbeelding}
                              title={image.product_afbeelding_tekst}
                            />
                          )
                        })}
                      </ArticleGrid>
                    </section>
                  )
                })}

                <InformationItem
                  informationMedia="wrapper-hero-video informationMedia informationMedia-video order2"
                  videoLink=""
                  channel="vimeo"
                  pictureURL={pagedetails.what_women_want_image}
                  informationContent="informationContent"
                  h3className="informationTitle mb0"
                  pClassName="informationParagraph"
                  Title={pagedetails.what_women_want_titel}
                >
                  {pagedetails.what_women_want_tekst}
                </InformationItem>
              </div>
            </div>
          </div>
        </main>
      ];
    }
  }
}

export default translate()(Assortment)



// WEBPACK FOOTER //
// ./src/Pages/Assortment.jsx